import axios from '../utils/axios';

export default function fetchAllOtherFunctionalArea(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/other-functional-areas', { params })
    )
}
